<ng-container *ngIf="permConfig.isAddAllowed">
<div class="container-fluid">
    <app-page-title title="Supplementary Invoice Generation"></app-page-title>
    <form [formGroup]="invoiceForm" (ngSubmit)="generateInvoice();" (keydown.enter)="$event.preventDefault()">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="billType" class="form-label">Bill Type<span class="mandatory">*</span></label>
                                    <ng-select id="billType" [items]="billTypeList" placeholder="Select"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('ddlBillType')?.touched) && invoiceForm.get('ddlBillType').errors}"
                                        [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlBillType" ></ng-select>
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('ddlBillType')?.touched) && invoiceForm.get('ddlBillType').errors"
                                        class="invalid-feedback">
                                    <span *ngIf="invoiceForm.get('ddlBillType').errors.required">Bill Type is Required</span>
                                    </div>
                                </div>
                            </div> 
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="company" class="form-label">Company<span class="mandatory">*</span></label>
                                    <ng-select id="company" formControlName="ddlCompany" [items]="companyList"
                                        [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'id'"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('ddlCompany')?.touched) && invoiceForm.get('ddlCompany').errors}"
                                        placeholder="Select"  ></ng-select>
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('ddlCompany')?.touched) && invoiceForm.get('ddlCompany').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('ddlCompany').errors.required">Company
                                            is Required</span>
                                    </div>
                                </div>
                            </div> 
                            <!-- (change)="onChangeCompany()" previusly it was there in the company to change  -->
                            <!-- <div class="col-md-2" *ngIf="isBillToServiceCenter">
                                <div class="mb-2">
                                    <label for="serviceCenter" class="form-label">Service Center<span class="mandatory">*</span></label>
                                    <ng-select id="serviceCenter" [items]="ServiceCenterOptions" bindLabel="name"
                                        placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                        formControlName="ddlServiceCenter"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('ddlServiceCenter')?.touched) && invoiceForm.get('ddlServiceCenter').errors}" >
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('ddlServiceCenter')?.touched) && invoiceForm.get('ddlServiceCenter').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('ddlServiceCenter').errors.required">Service Center
                                            is Required</span>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="invoiceDate" class="form-label">Invoice Date<span class="mandatory">*</span></label>
                                    <input id="invoiceDate" class="form-control form-control-sm" type="date"
                                        placeholder="Select" formControlName="txtInvoiceDate"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtInvoiceDate')?.touched) && invoiceForm.get('txtInvoiceDate').errors}" >
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('txtInvoiceDate')?.touched) && invoiceForm.get('txtInvoiceDate').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('txtInvoiceDate').errors.required">Invoice Date is
                                            Required</span>
                                    </div>
                                </div>
                            </div> 
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="InvoiceNo" class="form-label">Invoice No.</label>
                                    <input type="number" formControlName="txtInvoiceNo"
                                        class="form-control form-control-sm" id="InvoiceNo"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtInvoiceNo')?.touched) && invoiceForm.get('txtInvoiceNo').errors}" >
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('txtInvoiceNo')?.touched) && invoiceForm.get('txtInvoiceNo').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('txtInvoiceNo').errors.pattern">Maximum upto 15
                                            digits allowed.</span>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="toDate" class="form-label">BOE Date</label>
                                    <input id="toDate" class="form-control form-control-sm" type="date"
                                        placeholder="Select" formControlName="txtBOEDate"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtBOEDate')?.touched) && invoiceForm.get('txtBOEDate').errors}" >
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('txtBOEDate')?.touched) && invoiceForm.get('txtBOEDate').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('txtBOEDate').errors.required">Invoice is
                                            Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="boeNo" class="form-label">BOE No.</label>
                                    <input type="text" maxlength="30" class="form-control form-control-sm" id="boeNo"
                                    formControlName="txtBOENo" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="awbNo" class="form-label">AWB No.<span class="mandatory">*</span></label>
                                    <input type="text" maxlength="30" class="form-control form-control-sm" id="awbNo"
                                    formControlName="txtAwbNo"
                                    (change)="getBillToDetails()" (keydown.enter)="getBillToDetails()"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtAwbNo')?.touched) && invoiceForm.get('txtAwbNo').errors}" >
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('txtAwbNo')?.touched) && invoiceForm.get('txtAwbNo').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('txtAwbNo').errors.required">AWB No. is Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="mb-2">
                                    <label for="itemfuel" class="form-label">Bill To</label>
                                    <div role="group" aria-label="Item fuel" class="btn-group btn-group-sm d-flex">
                                        <input type="radio" id="btnbillto1" autocomplete="off" checked="" class="btn-check"
                                            value="sender" (change)="'getChargeItemValue()'" formControlName="switchSenderRecv" (change)="bindBillToDetails('shipper')" />
                                        <label for="btnbillto1" class="btn btn-outline-secondary">Shipper</label>
                                        <input type="radio" id="btnbillto2" autocomplete="off" class="btn-check" 
                                            value="reciever" (change)="'getChargeItemValue()'" formControlName="switchSenderRecv" (change)="bindBillToDetails('consignee')" />
                                        <label for="btnbillto2" class="btn btn-outline-secondary">Consignee</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Bill To Details</div>
                    <div class="card-body">
                        <div formGroupName="infoForm">
                            <div class="row" >                        
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="name" class="form-label">Name </label>
                                        <input type="text" class="form-control form-control-sm" id="name"
                                        placeholder="Search or Enter Name" [resultTemplate]="rt" [inputFormatter]="formatter"
                                        formControlName="txtName" [ngbTypeahead]="search"
                                        (selectItem)="selectedItemEvent($event)"/>    
                                        
                                        <ng-template #rt let-r="result" let-t="term">
                                            <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                                            <span> | {{ r['code'] }}</span>
                                        </ng-template>
                                    </div>

                                </div>
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="conatctperson" class="form-label">Contact Person </label>
                                        <input type="text" class="form-control form-control-sm" id="conatctperson"
                                            formControlName="txtConatctPerson" >                            
                                    </div>
                                </div>
                            </div>
                        </div>

                        <app-location formGroupName="locationForm" [formSubmitted]="isFormSubmitted" [location]="locationInfo"
                            (getLocation)="getLocation($event)" (manualFieldChange)="($event === 'state') && documentTypeValidation()">
                        </app-location>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Billing Info</div>
                    <div class="card-body" formGroupName="billingInfoForm">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="mb-2">
                                  <label for="documentType" class="form-label">Document Type</label>
                                  <ng-select id="documentType" [items]="documentOptions" bindLabel="name" [bindValue]="'name'"
                                    [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlDocumentType" placeholder="Select" 
                                    (change)="documentTypeValidation()">
                                  </ng-select>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="mb-2">
                                  <label for="documentNo" class="form-label">Document No.</label>
                                  <input type="text" class="form-control form-control-sm" id="documentNo" formControlName="ddlDocumentNo" [maxlength]="limitChars"
                                  (change)="validateGSTINStateSelection($event.target.value)"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('billingInfoForm.ddlDocumentNo').touched) &&
                                     invoiceForm.get('billingInfoForm.ddlDocumentNo').errors}" >
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('billingInfoForm.ddlDocumentNo').touched) && invoiceForm.get('billingInfoForm.ddlDocumentNo').errors" 
                                            class="invalid-feedback">
                                    <span *ngIf="invoiceForm.get('billingInfoForm.ddlDocumentNo').errors.required">Document No. is required.</span>
                                    <span *ngIf="invoiceForm.get('billingInfoForm.ddlDocumentNo').errors.pattern">{{docValidationMsg}}</span>
                                    </div>
                                </div>
                              </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                                <div class="mb-2">
                                    <label class="form-label" for="remark">Remark</label>
                                    <textarea id="remark" class="form-control custom-textbox" placeholder="Optional"
                                                formControlName="txtRemark" (keyup)="countCharcter()"
                                    [ngClass]="{'is-invalid': (CountReachedMsg || invoiceForm.get('billingInfoForm.txtRemark').touched) && invoiceForm.get('billingInfoForm.txtRemark').errors}" >
                                    </textarea>
                                    <div
                                    *ngIf="(CountReachedMsg || invoiceForm.get('billingInfoForm.txtRemark').touched) && invoiceForm.get('billingInfoForm.txtRemark').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="invoiceForm.get('billingInfoForm.txtRemark').errors.pattern">Maximum charcter Count ({{characterLimit}}) exceeded.</span>
                                    </div>
                                </div>
                            </div>
                          </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header bg-transparent border-bottom text-uppercase">Additional</div>
            <div class="card-body">
                <div class="row">
                    <div class="row mt-3" formGroupName="chargesForm">
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="description" class="form-label">Description<span class="mandatory">*</span></label>
                                <ng-select [items]="formattedChargeList"  bindLabel="name" [bindValue]="'id'" id="description" (change)="calculateFuelTax($event, true, false);"
                                    formControlName="txtDescription" (click)="setValidators('add')" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" 
                                    [ngClass]="{ 'is-invalid': (isAdditionalSubmitted || invoiceForm.get('chargesForm.txtDescription')?.touched) && invoiceForm.get('chargesForm.txtDescription').errors}" >
                                </ng-select>
                                <div *ngIf="(isAdditionalSubmitted || invoiceForm.get('chargesForm.txtDescription')?.touched) && invoiceForm.get('chargesForm.txtDescription').errors" class="invalid-feedback">
                                    <span *ngIf="invoiceForm.get('chargesForm.txtDescription').errors.required">Description is Required.</span>
                                </div>
                            </div>
                        </div>
            
                        <div class="col-md-1">
                            <div class="mb-2">
                                <label for="amount" class="form-label">Amount<span class="mandatory">*</span></label>
                                <input type="number" class="form-control form-control-sm" id="amount"
                                    formControlName="txtAmount" (keyup)="calculateTotalCharge()"
                                    [ngClass]="{'is-invalid':(isAdditionalSubmitted ||invoiceForm.get('chargesForm.txtAmount')?.touched) && invoiceForm.get('chargesForm.txtAmount').errors}"  />
                                <div *ngIf="(isAdditionalSubmitted ||invoiceForm.get('chargesForm.txtAmount')?.touched) && invoiceForm.get('chargesForm.txtAmount').errors" class="invalid-feedback">
                                    <span *ngIf="invoiceForm.get('chargesForm.txtAmount').errors.pattern">Please enter a number with up to 10 digits and at most two decimal places.</span>
                                    <span *ngIf="invoiceForm.get('chargesForm.txtAmount').errors.required">Amount is Required</span>
                                </div>
                            </div>
                        </div>
            
                        <!-- <div class="col-md-1">
                            <div class="mb-2">
                                <label for="fuel" class="form-label">Fuel &nbsp;</label>
                                <div role="group" aria-label="fuel" class="btn-group btn-group-sm d-flex">
                                    <input type="radio" id="btnfuelradio1" autocomplete="off" checked="" class="btn-check"
                                        value="Yes" (change)="'getChargeItemValue()'" formControlName="chkFuel"  />
                                    <label for="btnfuelradio1" class="btn btn-outline-secondary">Yes</label>
                                    <input type="radio" id="btnfuelradio2" autocomplete="off" class="btn-check" value="No"
                                        (change)="'getChargeItemValue()'" formControlName="chkFuel"  />
                                    <label for="btnfuelradio2" class="btn btn-outline-secondary">No</label>
                                </div>
                            </div>
                        </div>
            
                        <div class="col-md-1">
                            <div class="mb-2">
                                <label for="fuelamt" class="form-label">Fuel Amt</label>
                                <input type="number" class="form-control form-control-sm" id="fuelamt" formControlName="txtFuelAmt"
                                    (keyup)="'getChargeItemValue()'" (keydown)="'chargeDisable($event)'" 
                                    [ngClass]="{'is-invalid':(isAdditionalSubmitted || invoiceForm.get('chargesForm.txtFuelAmt')?.touched) && invoiceForm.get('chargesForm.txtFuelAmt').errors}" disabled  />
                                <div *ngIf="(isAdditionalSubmitted || invoiceForm.get('chargesForm.txtFuelAmt')?.touched) && invoiceForm.get('chargesForm.txtFuelAmt').errors" class="invalid-feedback">
                                    <span *ngIf="invoiceForm.get('chargesForm.txtFuelAmt').errors.pattern">Please enter a number with up to 10 digits and at most two decimal places.</span>
                                </div>
                            </div>
                        </div>
            
                        <div class="col-md-1">
                            <div class="mb-2">
                                <label for="itemfuel" class="form-label">Fuel Tax &nbsp;</label>
                                <div role="group" aria-label="fuel Tax" class="btn-group btn-group-sm d-flex">
                                    <input type="radio" formControlName="chkFuelTax" id="btnradio1" autocomplete="off" checked=""
                                        class="btn-check" value="Yes" (change)="'getChargeItemValue()'"  />
                                    <label for="btnradio1" class="btn btn-outline-secondary">Yes</label>
                                    <input type="radio" formControlName="chkFuelTax" id="btnradio2" autocomplete="off"
                                        class="btn-check" value="No" (change)="'getChargeItemValue()'"  />
                                    <label for="btnradio2" class="btn btn-outline-secondary">No</label>
                                </div>
                            </div>
                        </div>
            
                        <div class="col-md-1">
                            <div class="mb-2">
                                <label for="fueltaxamt" class="form-label">Fuel Tax Amt</label>
                                <input type="number" class="form-control form-control-sm" id="fueltaxamt"
                                    formControlName="txtFuelTaxAmount" (keyup)="'getChargeItemValue()'"
                                    (keydown)="'chargeDisable($event)'" 
                                    [ngClass]="{'is-invalid':(isAdditionalSubmitted ||invoiceForm.get('chargesForm.txtFuelTaxAmount')?.touched) && invoiceForm.get('chargesForm.txtFuelTaxAmount').errors}"  />
                                <div *ngIf="(isAdditionalSubmitted || invoiceForm.get('chargesForm.txtFuelTaxAmount')?.touched) && invoiceForm.get('chargesForm.txtFuelTaxAmount').errors" class="invalid-feedback">
                                    <span *ngIf="invoiceForm.get('chargesForm.txtFuelTaxAmount').errors.pattern">Please enter a number with up to 10 digits and at most two decimal places.</span>
                                </div>
                            </div>
                        </div> -->
            
                        <div class="col-md-1">
                            <div class="mb-2">
                                <label for="tax" class="form-label">Tax&nbsp;</label>
                                <div role="group" aria-label="Tax" class="btn-group btn-group-sm d-flex">
                                    <input type="radio" formControlName="chkTax" id="btntaxradio1" autocomplete="off" checked=""
                                        class="btn-check" value="Yes" (change)="calculateFuelTax(null, false, true)" />
                                    <label for="btntaxradio1" class="btn btn-outline-secondary">Yes</label>
                                    <input type="radio" formControlName="chkTax" id="btntaxradio2" autocomplete="off"
                                        class="btn-check" value="No" (change)="calculateFuelTax(null, false, true)"  />
                                    <label for="btntaxradio2" class="btn btn-outline-secondary">No</label>
                                </div>
                            </div>
                        </div>
            
                        <div class="col-md-1">
                            <div class="mb-2">
                                <label for="taxamt" class="form-label">Tax Amt</label>
                                <input type="number" class="form-control form-control-sm" id="taxamt" formControlName="txtTaxAmount"
                                    [ngClass]="{'is-invalid':(isAdditionalSubmitted || invoiceForm.get('chargesForm.txtTaxAmount')?.touched) && invoiceForm.get('chargesForm.txtTaxAmount').errors}" disabled  />
                                <div *ngIf="(isAdditionalSubmitted || invoiceForm.get('chargesForm.txtTaxAmount')?.touched) && invoiceForm.get('chargesForm.txtTaxAmount').errors" class="invalid-feedback">
                                    <span *ngIf="invoiceForm.get('chargesForm.txtTaxAmount').errors.pattern">Please enter a number with up to 10 digits and at most two  decimal places.</span>
                                </div>
                            </div>
                        </div>
            
                        <div class="col-md-1">
                            <div class="mb-2">
                                <label for="total" class="form-label">Total</label>
                                <input type="number" class="form-control form-control-sm" id="total" formControlName="txtTotal" 
                                    (input)="calculateReverseAmount()"
                                    [ngClass]="{'is-invalid':(isAdditionalSubmitted ||invoiceForm.get('chargesForm.txtTotal')?.touched) && invoiceForm.get('chargesForm.txtTotal').errors}"  />
                                <div *ngIf="(isAdditionalSubmitted || invoiceForm.get('chargesForm.txtTotal')?.touched) && invoiceForm.get('chargesForm.txtTotal').errors" class="invalid-feedback">
                                    <span *ngIf="invoiceForm.get('chargesForm.txtTotal').errors.pattern">Please enter a number with up to 10 digits and at most two decimal places.</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2 mt-3">
                            <div class="mb-2 mt-1">
                                <div *ngIf="!ischargesFormEdit">
                                    <button type="button" class="btn btn-primary btn-sm" (click)="upsertCharge('insert')">
                                        Add
                                    </button>
                                </div>
                                <div *ngIf="ischargesFormEdit">
                                    <button type="button" class="btn btn-primary btn-sm" (click)="upsertCharge('update')">
                                        Update
                                    </button>
                                    <button type="button" class="btn btn-secondary btn-sm" (click)="resetChargesForm()">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 grid-container">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                                [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                                [pagination]="true" (gridReady)="onGridReady($event)">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="button-items">
                    <button type="submit" class="btn btn-primary w-sm" >Generate</button>
                    <a routerLink="/invoices/supplementary">
                        <button type="button" class="btn btn-secondary w-sm">Cancel</button>
                    </a>
                </div>
            </div>
        </div>
    </form>
</div>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>